"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/// <summary>
/// Polyfill for the EcmaScript6 data type (JsSet)
/// This is mainly for Android browsers (4.4 and 5.0 does not support sets yet)
/// #crossbrowser: Remove once Android browsers for 4.4 and 5.0 no longer supported
/// </summary>
var JsSetPolyfillImpl = /** @class */ (function () {
    function JsSetPolyfillImpl() {
        // tslint:disable:no-any
        this.store = {};
    }
    Object.defineProperty(JsSetPolyfillImpl.prototype, "size", {
        // tslint:enable:no-any
        get: function () {
            return Object.keys(this.store).length;
        },
        enumerable: true,
        configurable: true
    });
    /// <summary>
    /// Appends a new element with the given value to the Set object.
    /// </summary>
    /// <param name="i"></param>
    /// <returns>Returns the Set object (this)</returns>
    JsSetPolyfillImpl.prototype.add = function (i) {
        // todo: handle asserts
        // Debug.Assert(i is string || i is int, "Invalid type of the dictionary key.");
        this.store[i] = i;
        return this;
    };
    /// <summary>
    /// Removes the element associated to the value
    /// </summary>
    /// <param name="i">The value that Set.prototype.has(value) would have previously returned</param>
    JsSetPolyfillImpl.prototype.delete = function (i) {
        var result = this.has(i);
        delete this.store[i];
        return result;
    };
    /// <summary>
    /// Removes all elements from the Set object.
    /// </summary>
    JsSetPolyfillImpl.prototype.clear = function () {
        this.store = {};
    };
    /// <summary>
    /// Returns a boolean asserting whether an element is present with the given value in the Set object or not.
    /// </summary>
    /// <param name="i"></param>
    /// <returns>true if entry present in the set</returns>
    JsSetPolyfillImpl.prototype.has = function (i) {
        return this.store.propertyIsEnumerable(i);
    };
    /// <summary>
    /// Calls callbackFn once for each value present in the Set object, in insertion order
    /// </summary>
    /// <param name="callbackFn">Function to invoke for every entry in the set</param>
    JsSetPolyfillImpl.prototype.forEach = function (callbackFn) {
        var _this = this;
        Object.keys(this.store).forEach(function (key) {
            callbackFn(_this.store[key]);
        });
    };
    return JsSetPolyfillImpl;
}());
exports.JsSetPolyfillImpl = JsSetPolyfillImpl;
//# sourceMappingURL=JsSetPolyfillImpl.js.map